module.exports = __webpack_public_path__ + "img/g2.7c28eeaf.jpg";